let cardList = document.getElementById('cardList');


checkWidthAndExecute();

window.addEventListener('resize', function () {
    checkWidthAndExecute();
});

function checkWidthAndExecute() {
    var screenWidth = window.innerWidth;

    if (screenWidth <= 1200) {
        cardList.classList.add('owl-carousel')
        owlInit()
    } else {
        cardList.classList.remove('owl-carousel')
        owlInit()
    }
}

function owlInit() {
    jQuery(document).ready(function ($) {
        $(document).ready(function () {
            $("#cardList.owl-carousel").owlCarousel({
                nav: true,
                dots: false,
                loop: true,

                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                    },
                    // breakpoint from 480 up
                    768: {
                        items: 2,
                    },
                    // breakpoint from 768 up
                    // 768 : {
                    //     items:1,
                    // }
                },

                navText : [ '<div class="wrp_svg"><svg viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.1265 26L17.3325 21.8341L8.41335 13L17.3325 4.16591L13.1265 -1.90735e-06L4.20732 8.83409L0.00128555 13L4.20732 17.1659L13.1265 26Z" fill="#D9B612"/></svg></div>',
                            '<div class="wrp_svg"><svg  viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.20652 26L0.000488281 21.8341L8.91966 13L0.000488281 4.16591L4.20652 -1.90735e-06L13.1257 8.83409L17.3317 13L13.1257 17.1659L4.20652 26Z" fill="#D9B612"/></svg></div>'
                ],
            });
        });
    })
}

jQuery(document).ready(function ($) {
    $(document).ready(function () {
        let reviewOwl = $("#reviewList.owl-carousel").owlCarousel({
            nav: true,
            dots: false,
            loop: true,
            margin: 10,
            center: true, // Включаем центрацию
            responsive: {
                // breakpoint from 0 up
                0: {
                    items: 1,
                },
                // breakpoint from 480 up
                992: {
                    items: 3,
                },
                // breakpoint from 768 up
                // 768 : {
                //     items:1,
                // }
            },

            navText : [ '<div class="wrp_svg"><svg  viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.1265 26L17.3325 21.8341L8.41335 13L17.3325 4.16591L13.1265 -1.90735e-06L4.20732 8.83409L0.00128555 13L4.20732 17.1659L13.1265 26Z" fill="#D9B612"/></svg></div>',
                        '<div class="wrp_svg"><svg  viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.20652 26L0.000488281 21.8341L8.91966 13L0.000488281 4.16591L4.20652 -1.90735e-06L13.1257 8.83409L17.3317 13L13.1257 17.1659L4.20652 26Z" fill="#D9B612"/></svg></div>'
            ],


            onInitialized: setCenterClass, // Устанавливаем центральный слайд после инициализации
            onTranslated: setCenterClass  // Обновляем центральный слайд при смене
        });

        function setCenterClass(event) {
            var items = $(event.target).find('.owl-item');
            items.removeClass('center'); // Удаляем класс центра у всех элементов
            var activeItems = items.filter('.active'); // Находим все активные слайды
            var centerIndex = Math.floor(activeItems.length / 2); // Находим центральный слайд
            $(activeItems[centerIndex]).addClass('center'); // Добавляем класс центральному слайду
        }


        reviewOwl.on('drag.owl.carousel', function (event) {
            console.log('drag.owl.carousel')
        })
    });
})

// const accordionHeaders = document.querySelectorAll('.accordion_header');
// accordionHeaders.forEach(header => {
//     header.addEventListener('click', function() {
//         // Переключаем состояние для текущего аккордеона
//         this.classList.toggle('active');
//         const content = this.nextElementSibling;
//         content.classList.toggle('show');
//     });
// });


let acHeader = document.getElementsByClassName("accordion_header");
let acContent = document.getElementsByClassName("accordion_content");
let i;

window.addEventListener("DOMContentLoaded", function () {
    for (i = 0; i < acHeader.length; i++) {
        if (acHeader[i].classList.contains("active")) {
            acContent[i].style.maxHeight = acContent[i].scrollHeight + "px"; // Устанавливаем высоту
        }
    }
});

for (i = 0; i < acHeader.length; i++) {
    acHeader[i].addEventListener("click", function () {


        // this.classList.toggle("active");
        // let panel = this.nextElementSibling;
        // if (panel.style.maxHeight) {
        //     panel.style.maxHeight = null;
        // } else {
        //     panel.style.maxHeight = panel.scrollHeight + "px";
        // }

        for (let j = 0; j < acHeader.length; j++) {
            if (acHeader[j] !== this) {
                acHeader[j].classList.remove("active");
                acContent[j].style.maxHeight = null; // Закрываем контент
            }
        }

        this.classList.toggle("active");
        let panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + 30 + "px";
        }

    });
}

document.querySelectorAll('.nav_head .nav-link[href*="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const href = this.getAttribute('href');

        const hash = new URL(href).hash; // Получаем '#faq'
        const sectionId = hash.slice(1);
        if (sectionId) {
            const targetElement = document.getElementById(sectionId);
            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop,
                    behavior: 'smooth'
                });
            }
        }
    });
});

const homeMenuItem = document.querySelector('#menu-header-menu-1 .menu-item-home .nav-link');
const homeMenuItem2 = document.querySelector('#menu-header-menu-2 .menu-item-home .nav-link');

homeMenuItem2.addEventListener('click', function(e) {
    e.preventDefault();
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});

document.addEventListener('scroll', function() {
    const menuItems = document.querySelectorAll('#menu-header-menu-1 .nav-link');
    const homeUrl = homeMenuItem ? homeMenuItem.getAttribute('href') : '';
    const isHomeUrlValid = homeUrl === window.location.origin || homeUrl === window.location.origin + '/';
    let sectionFoundInMenu = false;

    menuItems.forEach(item => {
        const href = item.getAttribute('href');
        if (href.includes('#')) {
            const sectionId = href.split('#')[1];
            const section = document.getElementById(sectionId);

            if (section) {
                const sectionTop = section.getBoundingClientRect().top + window.scrollY;
                const sectionHeight = section.offsetHeight;
                const scrollPosition = window.scrollY + window.innerHeight / 2;

                if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                    item.classList.add('active_link');
                    sectionFoundInMenu = true;
                } else {
                    item.classList.remove('active_link');
                }
            }
        }
    });

    if (!sectionFoundInMenu && isHomeUrlValid && homeMenuItem) {
        homeMenuItem.classList.add('active_link');
    } else if (homeMenuItem) {
        homeMenuItem.classList.remove('active_link');
    }

    homeMenuItem.addEventListener('click', function(event) {
        event.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

});